import React from 'react'

import TrendingModels from './TrendingModels/TrendingModels'
import Feed from './Feed/Feed'
import Jobs from './Jobs/Jobs'

function Dashboard() {
  return (
    <div className="seller-dashboard">
      <div style={{ clear: 'both' }} />
      <div className="container-fixed cgt-mt-20">

        <TrendingModels />

        <div className="row">
          <div className="col-12 col-xl-10 offset-xl-1">
            <Feed />
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <Jobs />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Dashboard
